import { useQuery } from '@tanstack/react-query';
import { getPotentialItineraries } from 'flux/clients/candidate';
import { useAccount } from '~/authentication/store';

import { TierHostItineraries } from '../model/PotentialItineraries';

type UsePotentialItinerariesHook = {
  itineraries: TierHostItineraries[];
  isLoading: boolean;
};

const QUERY_OPTS = {
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
  refetchOnMount: true,
};

function usePotentialItineraries(): UsePotentialItinerariesHook {
  const { account, loading } = useAccount();
  const accountId = account?.id;

  const response = useQuery(
    ['potential-itineraries', accountId],
    () => getPotentialItineraries(accountId),
    {
      ...QUERY_OPTS,
      select: (tierHostItineraries) => {
        return tierHostItineraries.map((tierHostItinerary) => {
          return {
            ...tierHostItinerary,
            potentialHostItineraries:
              tierHostItinerary.potentialHostItineraries.filter(
                (potentialItinerary) => {
                  // itineraries need a `pricePerNrOfGuests` property
                  if (
                    !potentialItinerary.itinerary.netPrice.pricePerNrOfGuests
                  ) {
                    return false;
                  }

                  // itineraries need a set of photos
                  if (
                    potentialItinerary.itinerary.platformProposition.details
                      .photos.length === 0
                  ) {
                    return false;
                  }

                  return true;
                },
              ),
          };
        });
      },
    },
  );

  return {
    itineraries: response.data || [],
    isLoading: response.isFetching || loading,
  };
}

export default usePotentialItineraries;
